class MQHelper {

    getBreakpoint() {
        return window.getComputedStyle(document.body, ':before').content.replace(/\"/g, '');
    }

}

export default new MQHelper();